import { useEffect, useState } from 'react';

import { apiClient, type FeedItem } from '@/services';

interface UseLiveMentionsResult {
  items: FeedItem[];
  loading: boolean;
}

export function useLiveMentions(): UseLiveMentionsResult {
  const [items, setItems] = useState<FeedItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    apiClient
      .getLiveFeed(controller.signal)
      .then((response) => {
        if (!controller.signal.aborted) setItems(response.items ?? []);
      })
      .catch(() => {})
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, []);

  return { items, loading };
}
